module.exports = __webpack_public_path__ + "static/media/eurasia-truck.43b83301.png";